<div class="modal-wrapper">
  <div class="overlay" *ngIf="blockui">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-6">
          <h4 class="modal-title" id="modal-basic-title">{{ comparable?.companyName }}</h4>
        </div>
        <div class="col-5" *ngIf="isMultiDB">
          <span class="ey-float-label db-dropdown">
            <select
              class="form-control form-select"
              id="comparable-database"
              name="comparableDatabase"
              [(ngModel)]="this.selectedDatabase"
              (change)="databaseSelected()"
              appLabelFloat
            >
              <option *ngFor="let database of comparableDatabases" [ngValue]="database">
                {{ database.databaseName }}
              </option>
            </select>
            <label>Database Source</label>
          </span>
        </div>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body fixed-body elimination-matrix-details pb-0">
    <div class="row" *ngIf="comparable">
      <div class="col-7 bdr-details">
        <app-bvd-display [comparable]="comparable" *ngIf="comparable && isBvd"></app-bvd-display>
        <app-non-bvd-display [comparable]="nonBvdComparableDetails" *ngIf="nonBvdComparableDetails && !isBvd"></app-non-bvd-display>
      </div>
      <div class="col-5">
        <div class="status">
          <a (click)="setAccepted()" class="accept" [class.accepted]="isAccepted" [class.disabled]="readOnly">
            <i class="material-icons">check_circle</i>
            <span>Accept</span>
          </a>
          <a (click)="setRejected()" class="reject" [class.rejected]="isRejected" [class.disabled]="readOnly">
            <i class="material-icons">cancel</i>
            <span>Reject</span>
          </a>
          <a (click)="setNeutral()" class="neutral" [class.neutral-set]="isNeutral" [class.disabled]="readOnly">
            <i class="material-icons">remove_circle</i>
            <span>Neutral</span>
          </a>
          <p-checkbox
            name="reviewed"
            class="bdr-reviewed-checkbox"
            label="Reviewed"
            [(ngModel)]="comparable.isReviewed"
            binary="true"
            (onChange)="setReviewedFlag()"
          >
          </p-checkbox>
        </div>
        <div class="shadow p-3">
          <div *ngIf="hasPredictionEngineResult">
            <div class="feedback-info">
              <i class="material-icons red">speaker_notes</i>
              AI recommendation
            </div>
          </div>
          <div class="section" [class.criteria-required]="invalidDecisionCriteria && isRejected">
            <span class="bold">Decision Criteria</span>
            <div class="ey-add-filter-body">
              <p-table [value]="criteriaColumns" [(selection)]="criteriaColumns" [scrollable]="true">
                <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                  <tr [pSelectableRow]="rowData" [class.criteria-disabled]="readOnly">
                    <td [ngClass]="{ 'decision-criteria': isAIDecisionColumn(rowData) && aiLayerEnabled }">
                      <div class="bdr-display-dialog-round">
                        <input
                          [disabled]="readOnly"
                          id="column_{{ index }}"
                          name="column_{{ index }}"
                          value="false"
                          [(ngModel)]="rowData.partialSelected"
                          #column="ngModel"
                          type="checkbox"
                          [title]="!readOnly ? (rowData.partialSelected ? '' : 'Please click to reject') : ''"
                          (click)="onFunctionDecisionTypeChangedFromCheckbox(rowData)"
                        />
                        <label for="column_{{ index }}"></label>
                      </div>
                      <div class="decision-criteria-value text">
                        <span>{{ rowData.label }}</span>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div>
              <span class="error-info" *ngIf="invalidDecisionCriteria && isRejected"> Please enter a valid Decision Criteria </span>
            </div>
          </div>

          <div *ngIf="this.study.isAISuggestionsEnabled">
            <div class="row">
              <div class="col-3 section">
                <span class="bold">AI Cluster</span>
                <div>
                  <span class="feedback-info">{{ comparable.aiClusterName }}</span>
                </div>
              </div>
              <div class="col-6 section">
                <span class="bold" ngbTooltip="{{ 'AIRecommendationAndConfidenceLevel_Header' | tpbTooltip }}">AI Recommendation & Confidence Level</span>
                <div>
                    <span class="feedback-info" [ngClass]="{'comparableStatusIsModified': iscomparableStatusIsModified(comparable) }">
                      <span *ngIf="comparable.predictionId === ComparableStatus.Accepted" class="material-icons icon-style" [ngClass]="{'accept-icon': !iscomparableStatusIsModified(comparable), 'accept-icon-disabled': iscomparableStatusIsModified(comparable)}">check_circle</span>
                      <span *ngIf="comparable.predictionId === ComparableStatus.Rejected" class="material-icons icon-style" [ngClass]="{'reject-icon': !iscomparableStatusIsModified(comparable), 'reject-icon-disabled': iscomparableStatusIsModified(comparable)}">cancel</span>
                      {{ comparable.aiConfidenceLevelName }}
                    </span>
                </div>
              </div>
              <div class="col-3 section">
                <span class="bold">AI Decision Source</span>
                <div>
                  <span class="feedback-info">{{ comparable.aiDecisionSourceName }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section" [class.has-error]="invalidRejectReason">
            <span class="bold">Reason</span>
            <div>
              <textarea
                appAutosize
                [disabled]="readOnly"
                class="form-control"
                id="reason"
                name="reason"
                [(ngModel)]="comparable.rejectedReason"
                (ngModelChange)="formChanged('rejectReason')"
                #reason="ngModel"
                maxlength="1000"
                minRows="2"
                minHeight="48"
                paddingHeight="32"
              ></textarea>
            </div>
            <div>
              <span class="error-info" *ngIf="invalidRejectReason && isRejected"> Please enter a rejection reason </span>
            </div>
          </div>
          <div class="section">
            <span class="bold">Subset</span>
            <div>
              <select
                class="form-control form-select"
                [disabled]="readOnly"
                [(ngModel)]="comparable.bdMatrixSubsetId"
                (ngModelChange)="formChanged()"
                #bdMatrixSubsetId="ngModel"
              >
                <option *ngIf="!comparable.bdMatrixSubsetId" [value]="0" disabled selected></option>
                <option *ngFor="let subset of allSubsets" [ngValue]="subset.bdMatrixSubsetId">
                  {{ subset.subsetName }}
                </option>
              </select>
            </div>
            <div *ngIf="comparable.bdMatrixSubsetId">
              <a [class.disabled]="readOnly" (click)="removeFromSubset()" class="remove-from-subset-link">
                <i class="pi pi-trash bottom-icon-size"> </i>
                <span>Remove from Subset</span>
              </a>
            </div>
          </div>
          <div class="section" *ngIf="this.study.isAISuggestionsEnabled">
            <span class="bold">AI Rationale</span>
            <div>
              <textarea appAutosize [disabled]="true" class="form-control" paddingHeight="32" [(ngModel)]="comparable.aiRational"></textarea>
            </div>
          </div>
          <div class="section">
            <span class="bold">Internal Notes</span>
            <div>
              <textarea
                appAutosize
                class="form-control"
                id="comment"
                name="comment"
                [disabled]="readOnly"
                [(ngModel)]="comparable.comment"
                (ngModelChange)="formChanged('InternalNotes')"
                #comment="ngModel"
                minRows="2"
                minHeight="48"
                paddingHeight="32"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="loadPrevious()"
      [disabled]="bdMatrixService.itemIndex < 1"
      style="min-height: 45px; min-width: 45px; padding: 0rem 0rem"
    >
      <i class="ey-menu-icon material-icons">chevron_left</i>
    </button>

    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="blockui || !formHasChanged" *ngIf="!readOnly">Save</button>

    <button
      type="button"
      class="btn btn-default"
      (click)="loadNext()"
      [disabled]="bdMatrixService.itemIndex >= bdMatrixService.comparableCount - 1"
      style="min-height: 45px; min-width: 45px; padding: 0rem 0rem"
    >
      <i class="ey-menu-icon material-icons">chevron_right</i>
    </button>

    <button
      type="button"
      *ngIf="showTranlateDescriptionButton && isBvd"
      class="btn btn-primary trans-description-btn"
      (click)="translateDescription()"
    >
      Translate Description
    </button>
  </div>
</div>
